import { render, staticRenderFns } from "./CreateLogin.vue?vue&type=template&id=4706e3ba&"
import script from "./CreateLogin.vue?vue&type=script&lang=js&"
export * from "./CreateLogin.vue?vue&type=script&lang=js&"
import style0 from "./CreateLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports